/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminProfileDto,
  ChangeAdminPasswordRequest,
  HttpValidationProblemDetails,
  OwnSessionDto,
  RevokeOtherSessionsResult,
  UpdateAdminProfileRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Return the authenticated admin's own profile row.
 */
export const adminProfileGetAdminMe = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminProfileDto>({ url: `/admin/me`, method: 'GET', signal }, options);
};

export const getAdminProfileGetAdminMeQueryKey = () => {
  return [`/admin/me`] as const;
};

export const getAdminProfileGetAdminMeQueryOptions = <
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminProfileGetAdminMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProfileGetAdminMe>>> = ({ signal }) =>
    adminProfileGetAdminMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminProfileGetAdminMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminProfileGetAdminMe>>
>;
export type AdminProfileGetAdminMeQueryError = unknown;

export function useAdminProfileGetAdminMe<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMe>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
          TError,
          Awaited<ReturnType<typeof adminProfileGetAdminMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminProfileGetAdminMe<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMe>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
          TError,
          Awaited<ReturnType<typeof adminProfileGetAdminMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminProfileGetAdminMe<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Return the authenticated admin's own profile row.
 */

export function useAdminProfileGetAdminMe<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminProfileGetAdminMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the authenticated admin's name and/or email. Email change revokes other active sessions.
 */
export const adminProfilePutAdminMe = (
  updateAdminProfileRequest: UpdateAdminProfileRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<AdminProfileDto>(
    {
      url: `/admin/me`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAdminProfileRequest,
    },
    options,
  );
};

export const getAdminProfilePutAdminMeMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminProfilePutAdminMe>>,
    TError,
    { data: UpdateAdminProfileRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminProfilePutAdminMe>>,
  TError,
  { data: UpdateAdminProfileRequest },
  TContext
> => {
  const mutationKey = ['adminProfilePutAdminMe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminProfilePutAdminMe>>,
    { data: UpdateAdminProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminProfilePutAdminMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminProfilePutAdminMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminProfilePutAdminMe>>
>;
export type AdminProfilePutAdminMeMutationBody = UpdateAdminProfileRequest;
export type AdminProfilePutAdminMeMutationError = HttpValidationProblemDetails;

/**
 * @summary Update the authenticated admin's name and/or email. Email change revokes other active sessions.
 */
export const useAdminProfilePutAdminMe = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminProfilePutAdminMe>>,
      TError,
      { data: UpdateAdminProfileRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminProfilePutAdminMe>>,
  TError,
  { data: UpdateAdminProfileRequest },
  TContext
> => {
  const mutationOptions = getAdminProfilePutAdminMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Verify current password and set a new one. Revokes other active sessions on success.
 */
export const adminProfilePostAdminMeChangePassword = (
  changeAdminPasswordRequest: ChangeAdminPasswordRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminProfileDto>(
    {
      url: `/admin/me/change-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changeAdminPasswordRequest,
      signal,
    },
    options,
  );
};

export const getAdminProfilePostAdminMeChangePasswordMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>,
    TError,
    { data: ChangeAdminPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>,
  TError,
  { data: ChangeAdminPasswordRequest },
  TContext
> => {
  const mutationKey = ['adminProfilePostAdminMeChangePassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>,
    { data: ChangeAdminPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminProfilePostAdminMeChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminProfilePostAdminMeChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>
>;
export type AdminProfilePostAdminMeChangePasswordMutationBody = ChangeAdminPasswordRequest;
export type AdminProfilePostAdminMeChangePasswordMutationError = HttpValidationProblemDetails;

/**
 * @summary Verify current password and set a new one. Revokes other active sessions on success.
 */
export const useAdminProfilePostAdminMeChangePassword = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>,
      TError,
      { data: ChangeAdminPasswordRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminProfilePostAdminMeChangePassword>>,
  TError,
  { data: ChangeAdminPasswordRequest },
  TContext
> => {
  const mutationOptions = getAdminProfilePostAdminMeChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List the caller's active sessions. The current device is flagged via IsCurrent.
 */
export const adminProfileGetAdminMeSessions = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<OwnSessionDto[]>({ url: `/admin/me/sessions`, method: 'GET', signal }, options);
};

export const getAdminProfileGetAdminMeSessionsQueryKey = () => {
  return [`/admin/me/sessions`] as const;
};

export const getAdminProfileGetAdminMeSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminProfileGetAdminMeSessionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>> = ({
    signal,
  }) => adminProfileGetAdminMeSessions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminProfileGetAdminMeSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>
>;
export type AdminProfileGetAdminMeSessionsQueryError = unknown;

export function useAdminProfileGetAdminMeSessions<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
          TError,
          Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminProfileGetAdminMeSessions<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
          TError,
          Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminProfileGetAdminMeSessions<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the caller's active sessions. The current device is flagged via IsCurrent.
 */

export function useAdminProfileGetAdminMeSessions<
  TData = Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminProfileGetAdminMeSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminProfileGetAdminMeSessionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Revoke one of the caller's own sessions. Idempotent.
 */
export const adminProfilePostAdminMeSessionsIdGuidRevoke = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<void>(
    { url: `/admin/me/sessions/${id}/revoke`, method: 'POST', signal },
    options,
  );
};

export const getAdminProfilePostAdminMeSessionsIdGuidRevokeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminProfilePostAdminMeSessionsIdGuidRevoke'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminProfilePostAdminMeSessionsIdGuidRevoke(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminProfilePostAdminMeSessionsIdGuidRevokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>
>;

export type AdminProfilePostAdminMeSessionsIdGuidRevokeMutationError = unknown;

/**
 * @summary Revoke one of the caller's own sessions. Idempotent.
 */
export const useAdminProfilePostAdminMeSessionsIdGuidRevoke = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsIdGuidRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminProfilePostAdminMeSessionsIdGuidRevokeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Revoke every session for this user except the caller's current one.
 */
export const adminProfilePostAdminMeSessionsRevokeOthers = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<RevokeOtherSessionsResult>(
    { url: `/admin/me/sessions/revoke-others`, method: 'POST', signal },
    options,
  );
};

export const getAdminProfilePostAdminMeSessionsRevokeOthersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminProfilePostAdminMeSessionsRevokeOthers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>,
    void
  > = () => {
    return adminProfilePostAdminMeSessionsRevokeOthers(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminProfilePostAdminMeSessionsRevokeOthersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>
>;

export type AdminProfilePostAdminMeSessionsRevokeOthersMutationError = unknown;

/**
 * @summary Revoke every session for this user except the caller's current one.
 */
export const useAdminProfilePostAdminMeSessionsRevokeOthers = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminProfilePostAdminMeSessionsRevokeOthers>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAdminProfilePostAdminMeSessionsRevokeOthersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
